import {
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Modal,
  TextField,
} from "@mui/material";
import { getDataInLocalstorage } from "common/method/getDataInLocalstorage";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTryUpdate,
} from "common/method/handleNotificationAlert";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { update_bank_accounts } from "redux/clubMember/update_bank_accounts";
import { actionTypes as actionProfile } from "redux/profile/clubmember_select_info";
const bankOptions = [
  // {
  //   id: 127,
  //   name: "بانک ملی ایران",
  // },
  // {
  //   id: 128,
  //   name: "بانک صادرات ایران",
  // },
  // {
  //   id: 129,
  //   name: "بانک آینده",
  // },
  // {
  //   id: 130,
  //   name: "بانک ملت",
  // },
  // {
  //   id: 131,
  //   name: "بانک دی",
  // },
  // {
  //   id: 122718,
  //   name: "بانک رفاه کارگران",
  // },
  // {
  //   id: 122795,
  //   name: "بانک پارسیان",
  // },
  // {
  //   id: 123101,
  //   name: "بانک اقتصاد نوین",
  // },
  // {
  //   id: 123103,
  //   name: "بانک ایران زمین",
  // },
  {
    id: 123104,
    name: "بانک پاسارگاد",
  },
  // {
  //   id: 123105,
  //   name: "بانک تجارت",
  // },
  // {
  //   id: 123106,
  //   name: "بانک توسعه صادرات ایران",
  // },
  // {
  //   id: 123108,
  //   name: "بانک خاورمیانه",
  // },
  // {
  //   id: 123109,
  //   name: "بانک سامان",
  // },
  // {
  //   id: 123110,
  //   name: "بانک سپه",
  // },
  // {
  //   id: 123111,
  //   name: "بانک شهر",
  // },
  // {
  //   id: 123112,
  //   name: "بانک صنعت و معدن",
  // },
  // {
  //   id: 123113,
  //   name: "بانک مسکن",
  // },
  // {
  //   id: 123114,
  //   name: "بانک کارآفرین",
  // },
  // {
  //   id: 123115,
  //   name: "بانک کشاورزی",
  // },
  // {
  //   id: 123116,
  //   name: "بانک سرمایه",
  // },
  // {
  //   id: 123118,
  //   name: "بانک سینا",
  // },
  // {
  //   id: 123119,
  //   name: "بانک گردشگری",
  // },
  // {
  //   id: 123122,
  //   name: "بانک قرض الحسنه رسالت",
  // },
  // {
  //   id: 123123,
  //   name: "بانک توسعه تعاون",
  // },
  // {
  //   id: 123133,
  //   name: "بانک پست بانک ایران",
  // },
  // {
  //   id: 123158,
  //   name: "بانک قرض الحسنه مهر ایران",
  // },
  // {
  //   id: 123160,
  //   name: "موسسه اعتباری ملل",
  // },
  // {
  //   id: 123161,
  //   name: "بانک مرکزی",
  // },
  // {
  //   id: 123162,
  //   name: "بانک مشترک ایران ونزوئلا",
  // },
  // {
  //   id: 123163,
  //   name: "موسسه اعتباری نور",
  // },
  // {
  //   id: 123164,
  //   name: "موسسه اعتباری توسعه",
  // },
];
const BankListModal = ({ _data, modalOpen, handleCloseModal }) => {
  const user = getDataInLocalstorage();

  const [formData, setFormData] = useState({
    iban: "IR - ",
    accountNumber: "",
    bankName: bankOptions?.[0]?.id || "", // Default to the first bank id or empty string if none
    cardNumber: "",
  });

  const [errors, setErrors] = useState({});
  const [bankRecords, setBankRecords] = useState([]);
  const dispatch = useDispatch();

  const ibanRegex = /^IR\s\d{2}\s\d{3}\s\d{1}\s\d{4}\s\d{8}\s\d{6}$/;
  const formatIban = (iban) => {
    const cleanedIban = iban.replace(/[^0-9]/g, "");
    if (cleanedIban.length === 0) return "IR - ";

    const formattedIban =
      `IR ${cleanedIban.slice(0, 2)} ${cleanedIban.slice(2, 5)} ` +
      `${cleanedIban.slice(5, 6)} ${cleanedIban.slice(
        6,
        10
      )} ${cleanedIban.slice(10, 18)} ` +
      `${cleanedIban.slice(18, 24)}`;

    return formattedIban.trim();
  };
  const formatCardNumber = (cardNumber) => {
    const cleaned = cardNumber.replace(/[^0-9]/g, "");
    const limited = cleaned.slice(0, 16);
    const formatted = limited.match(/.{1,4}/g)?.join("-") || "";
    return formatted;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "iban") {
      setFormData({ ...formData, [name]: formatIban(value) });
    } else if (name === "cardNumber") {
      setFormData({ ...formData, [name]: formatCardNumber(value) });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.iban || !ibanRegex.test(formData.iban)) {
      newErrors.iban = "شماره شبا باید معتبر باشد .";
    }
    // if (!formData.accountNumber) {
    //   newErrors.accountNumber = "شماره حساب نباید خالی باشد.";
    // }
    if (!formData.bankName) {
      newErrors.bankName = "لطفاً نام بانک را انتخاب کنید.";
    }
    // if (!formData.cardNumber) {
    //   newErrors.cardNumber = "  شماره کارت نمی تواند خالی باشد.";
    // }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const newRecord = {
      ...formData,
      date: new Date().toLocaleDateString("fa-IR"),
    };
    setBankRecords([...bankRecords, newRecord]);

    insertCreditRequest();
  };

  const insertCreditRequest = () => {
    apiCall();
  };
  const [loading, setLoading] = useState(false);

  const apiCall = () => {
    const selectedBank = bankOptions.find(
      (bank) => bank.id === formData.bankName
    );
    const newAccount = {
      account_number: formData?.accountNumber.replace(/ /g, ""),
      bank_code: formData?.bankName,
      card_number: formData?.cardNumber.replace(/-/g, ""),
      bank_name: selectedBank?.name,
      sheba: formData?.iban.replace(/\s+/g, ""),
    };

    let data = {
      bank_accounts: [..._data, newAccount],
    };

    setLoading(true);
    update_bank_accounts({ data })
      .then((res) => handleNotificationAlertTryUpdate(res))
      .catch(() => handleNotificationAlertCatch())
      .finally(() => {
        setLoading(false);
        handleCloseModal();
        setFormData({
          iban: "IR - ",
          accountNumber: "",
          bankName: "",
          cardNumber: "",
        });

        dispatch({
          type: actionProfile.profileAsync,
          national_id: user?.member_national_id,
        });

        setErrors({});
      });
  };

  return (
    <Modal open={modalOpen} onClose={handleCloseModal}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "96%",
          maxWidth: 450,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 2,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h1 className="text-[#646464] text-lg text-center mb-3">
          ایجاد حساب بانکی
        </h1>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            margin: "0 auto",
            padding: 3,
            flexWrap: "wrap",
            width: "100%",
          }}
        >
          <div>
            <TextField
              style={{ fontFamily: "monospace", direction: "ltr" }}
              label="شماره شبا"
              name="iban"
              value={formData.iban}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.iban}
              helperText="IR بدون "
              inputProps={{ maxLength: 34 }}
            />

            {errors.iban && (
              <span style={{ color: "red", fontSize: 12 }}>{errors.iban}</span>
            )}
          </div>
          <div>
            <TextField
              style={{ flex: 1 }}
              select
              label="نام بانک"
              name="bankName"
              value={formData.bankName}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.bankName}
            >
              {bankOptions.map((bank) => (
                <MenuItem key={bank} value={bank.id}>
                  {bank.name}
                </MenuItem>
              ))}
            </TextField>
            {errors.bankName && (
              <span style={{ color: "red", fontSize: 12 }}>
                {errors.bankName}
              </span>
            )}
          </div>
          <div style={{ opacity: 0.5 }}>
            <TextField
              disabled
              style={{ flex: 1, direction: "ltr" }}
              label="شماره حساب"
              name="accountNumber"
              value={formData.accountNumber}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.accountNumber}
            />
            {errors.accountNumber && (
              <span style={{ color: "red", fontSize: 12 }}>
                {errors.accountNumber}
              </span>
            )}
          </div>

          <div style={{ opacity: 0.5 }}>
            <TextField
              disabled
              style={{
                flex: 1,
                width: "100%",
                display: "flex",
                direction: "ltr",
              }}
              label="شماره کارت"
              name="cardNumber"
              value={formData.cardNumber}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.cardNumber}
            />
            {errors.cardNumber && (
              <span style={{ color: "red", fontSize: 12 }}>
                {errors.cardNumber}
              </span>
            )}
          </div>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            mt: 2,
            gap: 2,
          }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ width: "40%" }}
            onClick={(e) => handleSubmit(e)}
            disabled={loading}
            size="small"
          >
            ثبت اطلاعات {loading && <CircularProgress size={13} />}
          </Button>
          <Button
            onClick={() => {
              handleCloseModal();
              setFormData({
                iban: "IR - ",
                accountNumber: "",
                bankName: "",
                cardNumber: "",
              });
              setErrors({});
            }}
            variant="outlined"
            color="secondary"
            sx={{ width: "40%" }}
            size="small"
          >
            بستن
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export { BankListModal };
